import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-branding',
  templateUrl: './branding.component.html',
  styleUrls: ['./branding.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BrandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
